// ----------------------------------------------------
//  This class helps with firebase querys etc.
// ----------------------------------------------------

import Vue from 'vue';
import fb from '@/shift/fb';
import agile from '@/shift/agile';


const agileFb = Vue.observable(
{
	updateSecurityRules()
	{
		const updateSecurityRules = fb.functions.httpsCallable('updateSecurityRules');

		updateSecurityRules()
		.then(result =>
		{
			console.log("* Updated security rules", result);
		})
		.catch(er =>
		{
			console.log("* Error security rules", er);
		});
	},

	updateUsersAccessCards()
	{
		const updateUsersAccessCards = fb.functions.httpsCallable('updateUsersAccessCards');

		updateUsersAccessCards()
		.then(result =>
		{
			console.log("* Updated access cards", result);
		})
		.catch(er =>
		{
			console.log("* Error updating access cards", er);
		});
	},


	// ----------------------------------
	//	Get deletion query
	// ----------------------------------

	getDevQueryStart(key, collection)
	{
		return fb.db
			.collection('dev-collection')
			.doc('dev-doc')
			.collection(key)
			.doc(key)
			.collection(collection);
	},


	// ----------------------------------
	//	Get user list
	// ----------------------------------

	updateUserPageList: null,
	userList: [],
	//disabledUserList: Vue.observable([]),
	isAlreadyLoadingUsers: false,
	//isAlreadyLoadingDisabledUsers: false,

	getUserList()
	{
		if (this.isAlreadyLoadingUsers) return;
		this.isAlreadyLoadingUsers = true;

		const listUsers = fb.functions.httpsCallable('listUsers');

		listUsers( { /*filters: { disabled: false }*/ } )
			.then(result =>
			{
				this.isAlreadyLoadingUsers = false;
				if (result.data.success)
				{

					// ------------------------------------------
					//	Before we update the dataprovider for
					//  the expandable panel, we need to remember
					//  which items that was open/expanded in the UI!
					// ------------------------------------------

					const tempItemsWasOpen = [];

					for (let i = 0; i < this.userList.length; i++)
					{
						if (this.userList[i].panelOpen) tempItemsWasOpen.push(this.userList[i].id);
					}


					// ---------------------------------------
					//	Ok, got them, clear list and move on
					//  to populate with new data
					// ---------------------------------------

					const tempUserList = [];
					let count = 0;



					// result.data.aiData is the array of users
					result.data.aiData.forEach(user =>
					{
						//console.log('**', user)
						// ---------------------------------------
						//	Parse users and push to dataprovider
						// ---------------------------------------

						// If customClaims doesnt exist, create dummy object so UI doesn't fail
						let customClaims = (!user.auth.customClaims) ? { accessCards: [] } : user.auth.customClaims;

						// Same with accessCards
						if (!customClaims.accessCards) customClaims.accessCards = [];


						// ------------------------------------------
						//	Title bar table, we list "clients"
						// ------------------------------------------

						// Get the client names and concatenate them for the title bar 'Access' column
						let clientsForTitle = '';
						let tempArray = [];

						for (let i = 0; i < customClaims.accessCards.length; i++)
						{
							let gotDuplicate = false;

							customClaims.accessCards[i].clientName = agile.getClientNameByKey(customClaims.accessCards[i].key);
							customClaims.accessCards[i].groupName = agile.getGroupNameByKey(customClaims.accessCards[i].key);
							customClaims.accessCards[i].projectName = agile.getProjectNameByKey(customClaims.accessCards[i].key);

							if (customClaims.accessCards[i].clientName !== null)
							{
								for (let j = 0; j < tempArray.length; j++)
								{
									if (customClaims.accessCards[i].clientName === tempArray[j]) gotDuplicate = true;
								}

								if (!gotDuplicate && customClaims.accessCards[i].clientName !== '' && customClaims.accessCards[i].clientName !== undefined)
								{
									clientsForTitle += customClaims.accessCards[i].clientName+', ';
									tempArray.push(customClaims.accessCards[i].clientName);
								}
							}
						}

						for (let i = customClaims.accessCards.length-1; i >= 0; i--)
						{
							if (customClaims.accessCards[i].clientName === null) customClaims.accessCards.splice(i, 1);
						}


						// Remove comma on last entry
						clientsForTitle = clientsForTitle.substring(0, clientsForTitle.length-2);


						// ------------------------------------------
						//	If user is super admin, show super card
						// ------------------------------------------

						if (customClaims.superAdmin)
						{
							customClaims.accessCards.unshift(
								{
									clientName: 'Super Administrator',
									groupName: '',
									projectName: '',
									l: 'super' // access level
								});

							// Overwrite this when super admin
							clientsForTitle = 'Super Administrator';
						}




						// ------------------------------------------
						//	We want to reset open/closed state on items
						//  that was open in the expansion panel
						// ------------------------------------------

						let thisWasOpenInExpansionPanel = false;

						for (let i = 0; i < tempItemsWasOpen.length; i++)
						{
							if (tempItemsWasOpen[i] === user.auth.uid) thisWasOpenInExpansionPanel = true;
						}

						// ------------------------------------------
						//	Start pushing
						// ------------------------------------------

						tempUserList.push(Vue.observable(
							{
								n: count++, // We just want a simple number to keep track of forms, id's are not safe to be used as property name appendixes
								id: user.auth.uid,
								name: user.auth.displayName,
								firstName: user.firestore.firstName,
								lastName: user.firestore.lastName,
								email: user.auth.email,
								disabled: user.auth.disabled,
								customClaims: customClaims,
								clientsListedforTitle: clientsForTitle,
								panelOpen: thisWasOpenInExpansionPanel,
							}));
					});

					//this.agile.sortBy(this.userList, 'name');
					agile.sortBy(tempUserList, this.lastSortedBy);

					// Now update the real dataprovider
					this.userList = tempUserList;
					if (this.updateUserPageList) this.updateUserPageList();

					//console.log('got users', tempUserList);

				}
				else
				{
					console.log("Error", result.data.error.message);
					//this.$root.$alert("Error", result.data.error.message);
				}

			})
			.catch(er =>
			{
				this.isAlreadyLoadingUsers = false;
				//this.$root.ai_app.showProgressWheel = false;
				//this.$root.$alert("Error", er);
				console.log("Error", er);
			});

	},

    // ----------------------------------
    //	List accessible projects for user
    // ----------------------------------

    /* listUserProjects(callBackDone, callBackError)
    {
		callBackDone; callBackError;
        fb.db.collection('projects').where('disabled', '==', false).get()
		.then((querySnapshot) =>
		{
            // Clear old project list for user
            agile.loggedInUser.projects = [];

			// Loop projects
			querySnapshot.forEach((doc) =>
			{
				const docData = doc.data();
				console.log('***', docData.projectName);
				agile.loggedInUser.projects.push( 
				{
					id: doc.id,
					name: docData.name,
					key: docData.key,
					variable: docData.variable,
					accessMap: docData.accessMap,
                    clientName: docData.clientName,
					groupName: docData.groupName,
					projectName: docData.projectName,
					prettyName: docData.prettyName,
				});
			});
			
            //agile.sortBy(agile.loggedInUser.projects, 'clientName');
            //console.log(agile.loggedInUser.projects);
			//return true;
		})
		.catch((error) =>
		{
            console.log("Error", error);
            //return false;
		});
    }, */
 /**/

    /* setActiveProject(key)
    {
        fb.db.collection('users').doc(agile.loggedInUser.uid).set( { currentProject: key }, { merge: true } )
		.then(() =>
		{
            console.log('Current project set for user:', key);
		})
		.catch((error) =>
		{
            console.log("Error", error);
            //return false;
		});
    } */

});

export default agileFb;